import { postJSON } from 'api/fetch';

export const toggleExperiment = value =>
  postJSON('/schedule_builder/toggle_experiment', {
    experiment_value: value,
  });
